<p-card header="Saldo-Übersicht" styleClass="mb-4">
    <ng-container *ngIf="calculated && calculationItems; else notCalculated">
        <!-- Start Balance — U01: Forderung/Guthaben statt blankem Vorzeichen -->
        @let startDesc = describeItemAmount(calculationItems.startAmount);
        <div class="flex justify-between items-center py-2 border-b">
            <span class="font-semibold">Anfangssaldo:</span>
            <span class="font-bold" [class]="startDesc.colorClass">
                @if (startDesc.kind !== 'AUSGEGLICHEN') {
                    {{ startDesc.label }}
                }
                {{ startDesc.formatted }}
            </span>
        </div>

        <!-- Grouped Calculation Items -->
        <ng-container *ngFor="let group of groupedItems | keyvalue">
            <div class="py-2 border-b">
                <div class="text-sm text-gray-500 mb-1">{{ group.key }}</div>
                <div *ngFor="let item of group.value" class="flex justify-between items-center pl-4 py-1">
                    <span class="text-sm">
                        <span *ngIf="item.originalAmountExists" class="line-through text-gray-400 mr-2">
                            {{ formatAmount(item.originalAmount, item.currency) }}
                        </span>
                        <span *ngIf="item.objectLabel; else objectIdOnly"
                              [pTooltip]="'#' + item.objectId">
                            {{ item.objectLabel }}
                        </span>
                        <ng-template #objectIdOnly>#{{ item.objectId }}</ng-template>
                    </span>
                    <!-- R2-5: Betrag + Farbe nach Forderungs-Wirkung (receivableEffect),
                         damit das Vorzeichen zur Bewegung der Übergabesumme passt
                         (Kulanz-Belastung +, kein widersprüchliches Minus). -->
                    <span [class]="itemEffectColorClass(item)">
                        {{ formatItemEffect(item) }}
                    </span>
                </div>
            </div>
        </ng-container>

        <!--
            TM-1000001930: Freigewordene Storno-Beträge.
            Je Position eine Zeile mit deutschem Label (vom Backend) und Betrag.
            AGREEMENT_FEE ist saldowirksam (rot); KULANZ und OPEN_REMAINDER sind
            saldoneutral und werden klar als „ohne Saldo-Auswirkung" markiert.
        -->
        @if (hasFreedPositions) {
            <div class="py-2 border-b">
                <div class="text-sm text-gray-500 mb-1">Freigewordene Storno-Beträge</div>
                @for (position of freedPositions; track $index) {
                    <div class="flex justify-between items-center pl-4 py-1">
                        <span class="text-sm">
                            {{ position.label }}
                            @if (!isFreedPositionSaldoRelevant(position)) {
                                <span class="text-xs text-gray-400 ml-1">(ohne Saldo-Auswirkung)</span>
                            }
                        </span>
                        <span [class]="freedPositionColorClass(position)">
                            {{ formatAmount(position.amount) }}
                        </span>
                    </div>
                }
            </div>
        }

        <!-- End Balance — U01: eindeutige Forderung/Guthaben-Auszeichnung -->
        @let endDesc = endBalanceDescriptor;
        <div class="flex flex-column gap-1 py-3 mt-2 border-top-1 surface-border">
            <div class="flex justify-between items-center">
                <span class="font-bold text-lg">{{ endBalanceLabel }}</span>
                <span class="font-bold text-xl" [class]="endDesc.colorClass">
                    @if (endDesc.kind !== 'AUSGEGLICHEN') {
                        {{ endDesc.label }}
                    }
                    {{ endDesc.formatted }}
                </span>
            </div>
            <!-- Klartext-Bedeutung, damit der Sachbearbeiter den Betrag sicher liest -->
            @if (endDesc.kind === 'FORDERUNG') {
                <small class="text-red-600">
                    An Inkasso zu übergeben: {{ endDesc.formatted }} (offene Forderung).
                </small>
            } @else if (endDesc.kind === 'GUTHABEN') {
                <small class="text-green-600">
                    Guthaben zugunsten des Kunden: {{ endDesc.formatted }} — keine Forderung ans Inkasso.
                </small>
            } @else {
                <small class="text-color-secondary">Ausgeglichen — keine offene Forderung.</small>
            }
        </div>
    </ng-container>

    <ng-template #notCalculated>
        <div class="text-center text-gray-500 py-4">
            <i class="pi pi-calculator mr-2"></i>
            Klicken Sie auf „Berechnen", um die Saldo-Übersicht anzuzeigen
        </div>
    </ng-template>
</p-card>

<!-- Validation Messages -->
<p-card *ngIf="validated && messages" header="Prüfergebnis" styleClass="mt-4">
    <div *ngIf="!messages.hasErrors" class="text-green-600 flex items-center">
        <i class="pi pi-check-circle mr-2"></i>
        Prüfung erfolgreich – bereit zur Aktivierung
    </div>

    <div *ngFor="let message of messages.messages"
         class="p-2 mb-2 rounded flex items-start"
         [ngClass]="getSeverityClass(message.severity)">
        <i class="pi mr-2 mt-1"
           [ngClass]="{
               'pi-times-circle': message.severity === 'ERROR',
               'pi-exclamation-triangle': message.severity === 'WARNING',
               'pi-info-circle': message.severity === 'INFO'
           }"></i>
        <div>
            <div *ngIf="getMessageTypeLabel(message.type)" class="font-semibold">{{ getMessageTypeLabel(message.type) }}</div>
            <div class="text-sm">{{ message.message }}</div>
            <div *ngIf="message.referenceObjectType" class="text-xs mt-1">
                Referenz: {{ message.referenceObjectType }} #{{ message.referenceId }}
            </div>
        </div>
    </div>
</p-card>
